<nav id="listing-group" class="listing-group">
  <!-- <ion-button [ngClass]="{'ion-activatable': false}" color="secondary" *ngFor="let item of menuOptions" (click)="setShowMenu(item.id)" >
    <ion-icon slot="icon-only" [name]="this.range || this.moment ? 'chevron-up-outline' : 'chevron-down-outline'"  ></ion-icon>
    {{ item.name }}
  </ion-button> -->
  <ion-button  [ngClass]="{'ion-activatable': false}" color="secondary" (click)="setShowSelected()">Capas activas</ion-button> 
  <ion-button  [ngClass]="{'ion-activatable': false}" color="secondary" (click)="setShowModal()">Alertas</ion-button>  
</nav>